import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import PageLoader from 'app/components/PageLoader';
import Button from 'app/components/button';
import Toggle from 'react-toggle';
import Dropdown from 'app/components/Dropdown';
import NewAttachment from 'app/components/NewAttachment';
import NewInput from 'app/components/NewInput';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateMallBanner from './useCreateMallBanner';
import { useMemo } from 'react';
const CreateMallBanner = () => {
  const {
    mallList,
    bannerId,
    handleChange,
    values,
    error,
    handleCreateMall,
    pageLoading,
    hideFields,
    uploadMediaHandler,
    setChange,
    navigate,
  } = useCreateMallBanner();

  // navigate(-1) pops to the previous history entry, which has no mall_id in
  // its state — so the list came back unfiltered and forced re-selection.
  // Push the list route explicitly with the mall the user was working in.
  const goBackToBannerList = () =>
    navigate(APP_CONSTANTS.MALL_BANNER, {
      state: { mall_id: values.mall_id },
    });

  // Assuming `values` is a prop or state
  const dimensionLabel = useMemo(() => {
    return values?.img_type === 'mainBanner'
      ? '(375*360)'
      : values?.img_type === 'brandBanner'
      ? '(375*200)'
      : '';
  }, [values?.img_type]);
  console.log(dimensionLabel);

  // Use `dimensionLabel` in your component

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${bannerId ? ' Edit Mall Banner  ' : 'Create Mall Banner'}`}
          goTo={APP_CONSTANTS.MALL_BANNER}
          onBackClicked={goBackToBannerList}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <Dropdown
              id={'mall_id'}
              label='Mall List*'
              name='mall_id'
              options={mallList}
              placeholder='Select Mall '
              value={values.mall_id}
              handleChange={handleChange}
              isFieldHidden={hideFields}
              errorText={error?.mall_id}
            />
          </div>
          <div className='wd-50'>
            <Dropdown
              id={'img_type'}
              label='Banner Type*'
              name='img_type'
              options={[
                { label: 'Main Banner', value: 'mainBanner' },
                { label: 'Brand Banner', value: 'brandBanner' },
              ]}
              placeholder='Select Banner '
              value={values.img_type}
              handleChange={handleChange}
              isFieldHidden={hideFields}
              errorText={error?.img_type}
            />
          </div>
          <div className='wd-50'>
            <label>Caroal Image/ Video*</label>
            <NewAttachment
              value={values?.img_url ? values?.img_url : null}
              id='img_url'
              onFileSelected={uploadMediaHandler}
              fileType='image'
              label='Add Logo Image'
              errorText={error?.img_url}
              isDisabled={values?.img_type === '' ? true : false}
              customoparentclassName={'bannerparent'}
              customclassName={'bannerheight'}
              videoAllowed={values?.img_type === 'mainBanner' ? true : false}
              dimesnsionLabel={dimensionLabel}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Link URL'
              id='url'
              type='text'
              placeholder='https://example.com/promo'
              name='url'
              value={values?.url}
              onChange={handleChange}
              errorText={error?.url}
              isFieldHidden={hideFields}
            />
            <small className='tool-tip'>
              Only http(s) links are allowed. Leave blank to remove an
              existing link.
            </small>
          </div>
          <div className='wd-100'>
            <div className='d-block my-4'>
              <label className='me-2 d-inline-block tooltip-on-hover'>
                Status*
              </label>
              <label className='d-inline-block mt-2'>
                <div className='d-inline-flex align-items-center'>
                  <div className='d-inline-flex text-danger'>OFF</div>
                  <div className='d-inline-flex mx-2'>
                    <Toggle
                      checked={values.status}
                      icons={false}
                      onChange={() => setChange('status', !values.status)}
                    />
                  </div>
                  <div className='d-inline-flex text-green'>ON</div>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className=''
            onClick={handleCreateMall}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={goBackToBannerList}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateMallBanner;
